const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo">
              <i className="fas fa-pen-nib"></i>
              <span>Bungen Lee</span>
            </div>
            <p className="footer-description">
              Fantasy & Historical Fiction Author crafting immersive worlds and unforgettable adventures.
            </p>
            <div className="social-links">
              <a 
                href="https://www.instagram.com/bungenlee" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow on Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a 
                href="https://www.royalroad.com/profile/357215/fictions" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Read on Royal Road"
              >
                <i className="fas fa-crown"></i>
              </a>
              <a 
                href="https://www.wattpad.com/user/BungenLee" 
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Read on Wattpad"
              >
                <i className="fas fa-book"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h5>Reading Platforms</h5>
            <div className="footer-links">
              <a 
                href="https://books.apple.com/us/author/bungen-lee/id1687893127" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Apple
              </a>
              <a 
                href="https://www.smashwords.com/profile/view/BungenLee7295" 
                target="_blank"
                rel="noopener noreferrer"
              >
                SmashWords
              </a>
              <a 
                href="https://www.kobo.com/us/en/search?query=bungen+lee&ac=1&acp=bungen+lee&ac.author=bungen+lee&sort=Temperature&fcadultcontentallowed=true&fclanguages=en&ssid=RsPRdRazCFEn-Waop5a4P&sid=945255ca-f805-46f6-bbb3-e806223c3e68" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Rakuten Kobo
              </a>
              <a 
                href="https://www.barnesandnoble.com/s/%22Bungen%20Lee%22;jsessionid=BEBED42EBDB42273B694FDBC7BBF676C.prodny_store02-atgap07?Ntk=P_key_Contributor_List&Ns=P_Sales_Rank&Ntx=mode+matchall" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Barnes and Noble
              </a>
            </div>
          </div>
          
           </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Bungen Lee. All rights reserved.</p>
            <p className="footer-credits">
              Crafted with <i className="fas fa-heart"></i> for readers everywhere
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;